<div class="filters-row row align-items-center">
  <div *ngIf="sortOptions?.length" class="col-lg-4 col-md-12 sort-by">
    <div ngbDropdown class="dropdown w-100">
      <button
        class="form-control dropdown-toggle text-start"
        id="sortDropdown"
        ngbDropdownToggle
        type="button"
        [attr.aria-label]="'product.items.sorting.label' | translate"
      >
        {{ selectedSortLabel || ('product.items.sorting.label' | translate) }}
      </button>
  
      <div ngbDropdownMenu aria-labelledby="sortDropdown" class="w-100">
        <button
          *ngFor="let o of sortOptions"
          class="dropdown-item"
          [class.active]="o.value === sortBy"
          type="button"
          (click)="onSelectSort(o)"
        >
          {{ o.label }}
        </button>
      </div>
    </div>
  </div>

  <div class="col-4 col-md-6 col-lg-4">
    <div class="row">
      <div class="col-lg-6">
        <ish-product-list-paging
          *ngIf="pageIndices?.length && currentPage"
          [currentPage]="currentPage"
          [pageIndices]="pageIndices"
          [fragmentOnRouting]="fragmentOnRouting"
        ></ish-product-list-paging>
      </div>
      <div class="col-md-6">
        <div *ngIf="itemCount >= 0" class="pagination-total text-nowrap">
          {{ 'product.items.label' | translate : { '0': itemCount } }}
        </div>
      </div>
    </div>
  </div>

  <div
    class="col-8 col-md-6 col-lg-4 switch-layout"
    [ngClass]="{ 'col-lg-4': sortOptions?.length, 'col-lg-5': !sortOptions?.length }"
  >
    <div class="multi-grid-icons d-none d-lg-block" *ngIf="!listView">
      <a
        class="grid-view-link grid-2"
        [ngClass]="{ active: viewType === 'grid-2' }"
        data-testing-id="grid-view-link"
        [routerLink]="[]"
        queryParamsHandling="merge"
        [queryParams]="{ view: 'grid-2' }"
        [replaceUrl]="true"
        [fragment]="fragmentOnRouting"
      >
      </a>
      <a
        class="grid-view-link grid-3"
        [ngClass]="{ active: viewType === 'grid-3' || viewType === 'grid' }"
        data-testing-id="grid-view-link"
        [routerLink]="[]"
        queryParamsHandling="merge"
        [queryParams]="{ view: 'grid-3' }"
        [replaceUrl]="true"
        [fragment]="fragmentOnRouting"
      >
      </a>
      <a
        class="grid-view-link grid-4"
        [ngClass]="{ active: viewType === 'grid-4' }"
        data-testing-id="grid-view-link"
        [routerLink]="[]"
        queryParamsHandling="merge"
        [queryParams]="{ view: 'grid-4' }"
        [replaceUrl]="true"
        [fragment]="fragmentOnRouting"
      >
      </a>
      <a
        class="grid-view-link grid-5"
        [ngClass]="{ active: viewType === 'grid-5' }"
        data-testing-id="grid-view-link"
        [routerLink]="[]"
        queryParamsHandling="merge"
        [queryParams]="{ view: 'grid-5' }"
        [replaceUrl]="true"
        [fragment]="fragmentOnRouting"
      >
      </a>
    </div>

    <div class="sort-by text-right">
      <a
        class="list-view-link"
        [ngClass]="{ 'list-active': listView }"
        data-testing-id="list-view-link"
        [routerLink]="[]"
        queryParamsHandling="merge"
        [queryParams]="{ view: 'list' }"
        [replaceUrl]="true"
        [fragment]="fragmentOnRouting"
        role="button"
        aria-label="list view"
      >
        <fa-icon [icon]="['fas', 'list']"></fa-icon>
      </a>
      <a
        class="grid-view-link"
        [ngClass]="{ 'grid-active': gridView }"
        data-testing-id="grid-view-link"
        [routerLink]="[]"
        queryParamsHandling="merge"
        [queryParams]="{ view: 'grid-3' }"
        [replaceUrl]="true"
        [fragment]="fragmentOnRouting"
        role="button"
        aria-label="grid view"
      >
        <fa-icon [icon]="['fas', 'th']"></fa-icon>
      </a>
    </div>
  </div>
</div>
